import axios from "axios";
import { APP_Config } from "../../helpers/AppConfig";
import { modifyFormData } from "../../helpers/ServiceHelpers";
import Service from "../../services";

class researchInsighteService extends Service {
  base_url = APP_Config()?.REACT_APP_DOCUMENT_AI_URL;
  // URL only changed
  reserach_get_userquery = (payload:any,userId:any) =>{
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/lamma_reserach_get_userquery`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "user-id": userId,
          'chat-history-op':payload?.chat_history_op || ""
        },
      });
  }

  reserach_ingest_kdb = (payload: any, userId:any) =>{
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/lamma_reserach_ingest_kdb`, formData,{
      headers: {
        "Content-Type": "multipart/form-data",
        "user-id": userId,
      },
    })
  }

}

export default researchInsighteService;
